import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../AbstractElements';
import DataTablesContain from '../../Component/Tables/DataTable5';
import { useTranslation } from 'react-i18next';

const DataTable5 = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Breadcrumbs parent={t("Dashboard")} title={t("Verification")} />
      <DataTablesContain />
    </Fragment>
  );
};
export default DataTable5;
